// import React from "react";
// import face from "../../Assets/face-soon.JPG";

// const Section2 = () => {
//   return (
//     <div className="flex flex-col md:flex-row items-center justify-between bg-[#F2EFEA] p-8 md:p-16 ">
//       {/* Left Column: Image */}
//       <div className="w-full  flex justify-center md:justify-center ">
//         <img
//           src={face}
//           alt="Portrait"
//           className="w-[500px] h-auto object-cover rounded-lg shadow-md ml-40 mt-20"
//         />
//       </div>

//       {/* Right Column: Content */}
//       <div className="w-full md:w-1/2 mt-6 md:mt-0 text-black-900  ">
//         <div className="-ml-64 text-justify ">
//           <div className="text-black-500 text-md uppercase  tracking-widest mb-6 font-semibold ">
//             YOU DON'T HAVE TO DO IT ALONE.
//           </div>

//           <div className="max-w-xl">
//             <h1
//               className="text-3xl md:text-5xl leading-tight mb-6 pr-32"
//               style={{
//                 fontFamily: "Blacker Pro Display",
//               }}
//             >
//               Ready to grow your brand and attract your ideal clients?
//             </h1>
//             <p className="text-gray-600 text-xl leading-relaxed pr-32">
//               A Creative Studio bringing your vision to life, giving your brand
//               identity through timeless designs and impactful storytelling.At
//               Connect Engage Grow, we believe your brand deserves to be seen.
//               <br />
//               <br />
//               We’ll manage your digital marketing so you can focus on what you
//               do best. With strategic content and engaging visuals, we’ll help
//               you connect with your audience, engage meaningfully, and grow your
//               business.
//             </p>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Section2;
import React from "react";
import face from "../../Assets/change.JPG";

const Section2 = () => {
  return (
    <div className="bg-[#F2EFEA] px-4 sm:px-6 lg:px-8 pt-28 lg:py-32">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
          {/* Left Column: Image */}
          <div className="w-full lg:w-1/2">
            <div className="flex justify-center lg:justify-end">
              <img
                src={face}
                alt="Portrait"
                className="w-full h-[500px] sm:h-[550px] lg:h-[650px] max-w-[500px] sm:object-center object-cover rounded-lg shadow-md"
              />
            </div>
          </div>

          {/* Right Column: Content */}
          <div className="w-full lg:w-1/2">
            <div className="text-left max-w-xl">
              <div className="text-black-500 text-sm sm:text-md uppercase tracking-widest font-semibold mb-6">
                YOU DON'T HAVE TO DO IT ALONE
              </div>

              <h1
                className="text-2xl sm:text-3xl lg:text-5xl leading-tight mb-6"
                style={{
                  fontFamily: "Blacker Pro Display",
                }}
              >
                Ready to grow your brand and attract your ideal clients?
              </h1>

              <div className="space-y-6">
                <p className="text-gray-600 text-base sm:text-lg lg:text-xl leading-relaxed">
                  A Creative Studio bringing your vision to life, giving your
                  brand identity through timeless designs and impactful
                  storytelling. At Connect Engage Grow, we believe your brand
                  deserves to be seen.
                </p>

                <p className="text-gray-600 text-base sm:text-lg lg:text-xl leading-relaxed">
                  We'll manage your digital marketing so you can focus on what
                  you do best. With strategic content and engaging visuals,
                  we'll help you connect with your audience, engage
                  meaningfully, and grow your business.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section2;
